<template>
  <ResumeSection :toggle="!isToggleHidden"
                 :isOpen="isOpenOnMobile"
                 :activeTab="activeTab"
                 :title="$tResumePage('Дані з підбору вакансій')"
                 @tab-click="activeTab = $event"
                 class="resume-page__section">
    <template v-slot:icon>
      <BaseSvg name="ico-file-check-search"
               width="3.1157rem"
               height="3.3rem"/>
    </template>
    <template v-slot:default>
      <div class="resume-documents">
        <div class="resume-documents__inner">
          <ResumeDocumentsGroup
            v-for="(listItem, index) in items"
            :key="index"
            :item="listItem"
          />
        </div>
      </div>
    </template>
  </ResumeSection>
</template>

<script>
import ResumeDocumentsGroup from "@/components/resumeView/ResumeDocumentsGroup"
import ResumeSection from "./ResumeSection"

export default {
  name: 'ResumePrimarySelectionData',
  components: {
    ResumeSection,
    ResumeDocumentsGroup,
  },
  props: ['items', 'isOpenOnMobile', 'isToggleHidden'],
  data() {
    return {
      activeTab: 0
    }
  }
};
</script>
